import { getArgsAsTypesafeObjectProperties } from "../constants-util";

export const constants = getArgsAsTypesafeObjectProperties("NEW_TOKEN", "LOGOUT");
